import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ErrorMessage from './error-message';

// error boundary life cycle hook does not have function hook right now.
// temporarily using class component.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    const { hasError, error } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorMessage message={error.message} />
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.element.isRequired,
};

export default withRouter(ErrorBoundary);
